$(function () {
  $(".quicksearchcon-btn").click(function () {
    if ($(".indexsearch-container")) {
      // $(".indexsearch-container").stop().slideToggle();

    }

    if ($(".nav_background").is(":visible")) {
      $(".indexsearch-container").stop().slideUp();
      $(".header__outer-wrapper>.header").removeClass("search-holder");
      $(".nav_background").stop().fadeOut(500);

    } else {
      $(".indexsearch-container").stop().slideDown();
      $(".header__outer-wrapper>.header").addClass("search-holder");
      $(".nav_background").stop().fadeIn(500);
      
    }

  });
  $(".nav_background").click(function () {
    $(".indexsearch-container").stop().slideUp();
    $(".nav_background").stop().fadeOut(500);
    $(".header__outer-wrapper>.header").removeClass("search-holder");
  });
  $(".header__outer-wrapper").bind("click", function (evt) {
    if ($(evt.target).closest(".quicksearchcon-btn").length == 0 && $(evt.target).closest(".indexsearch-container").length == 0) {
      $(".indexsearch-container").stop().slideUp();
      $(".nav_background").stop().fadeOut(500);
      $(".header__outer-wrapper>.header").removeClass("search-holder");
    }
  });

  $(".mobile_newmenu-left>li").click(function () {
    let index = $(this).data("index");
    $(this).addClass("active").siblings().removeClass("active");
    $(".mbnavcon_right-" + index).show().siblings().hide();
  });

  $(document).ready(function() {
    // 选择所有的 a 元素
    $('.header-traanimate').on('mouseenter touchstart', function() {
      $(this).addClass('active');
    });
  
  });
  



})

// document.addEventListener('DOMContentLoaded', function () {
//   const lottiePlayers = document.querySelectorAll('lottie-player');

//   lottiePlayers.forEach(player => {
//     const parentElement = player.closest('.support-aniparent');
//     const nextElement = parentElement.querySelector('.suplot-svg');
//     if (parentElement) {
//       const handleMouseEnter = () => {
//         if(nextElement){
//           nextElement.style.display = 'none';
//         }
//         setTimeout(function() {
//           player.play();
//         }, 100); 
        
//         player.style.pointerEvents = "none";

//         player.addEventListener('complete', () => {
//           parentElement.removeEventListener('mouseenter', handleMouseEnter);
//           parentElement.removeEventListener('touchstart', handleMouseEnter); // 移动端的触摸事件也需要移除

//         });
//       };

//       parentElement.addEventListener('mouseenter', handleMouseEnter);
//       parentElement.addEventListener('touchstart', handleMouseEnter);  // 新增移动端的触摸事件

//       // if ($(window).width() < 769) {
//       //   handleMouseEnter();
//       // }
//     }
//   });
// });
